import React, { useEffect } from 'react';
import { App } from '@roku-web-core/app';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import * as Sentry from '@sentry/react';

import { AppProvider } from 'context/app';
import { ConfigProvider } from 'context/config';
import { LeavesProvider } from 'context/leaves';
import { SmartHomeDarkTheme } from 'global/themes';

interface AppParams {
  children: React.ReactNode;
}

const MyApp = ({ children }: AppParams) => {
  // Initialize Sentry feedback integration
  useEffect(() => {
    const { pageviewPrereqData } = App.getPageConfig();

    const feedbackIntegration = Sentry.feedbackIntegration({
      autoInject: false,
      colorScheme: 'light',
    });

    if (pageviewPrereqData?.isAlphaUser || pageviewPrereqData?.isEngineerUser) {
      const sentryWidget = feedbackIntegration.createWidget();
      sentryWidget.appendToDom();

      const buttonCssOverride = new CSSStyleSheet();
      buttonCssOverride.replaceSync(`
        .widget__actor {
          background: #EEE;
          border: none;
          font-weight: 500;
          padding: 12px;
        }
      `);

      const widgetElement = document.querySelector('#sentry-feedback');
      if (widgetElement && widgetElement.shadowRoot) {
        widgetElement.shadowRoot.adoptedStyleSheets.push(buttonCssOverride);
      }
    }
  }, []);

  return (
    <ConfigProvider>
      <AppProvider>
        <LeavesProvider>
          <ThemeProvider theme={SmartHomeDarkTheme}>
            <CssBaseline />
            {children}
          </ThemeProvider>
        </LeavesProvider>
      </AppProvider>
    </ConfigProvider>
  );
};

export default MyApp;
